import { render, staticRenderFns } from "./offcourse-drawer.vue?vue&type=template&id=4bb4cdf8&"
import script from "./offcourse-drawer.vue?vue&type=script&lang=js&"
export * from "./offcourse-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports